import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationPinRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.8 12.6c0-3.8 3.2-7 7.2-7s7.2 3.2 7.2 7q-.2 3.6-3 7.9Q18 23.9 16 26a46 46 0 0 1-4.3-5.6 16 16 0 0 1-2.9-7.9M16 3.2a9.5 9.5 0 0 0-9.6 9.4c0 6 6 13.1 8.5 15.9.6.6 1.6.6 2.2 0 2.5-2.8 8.5-9.9 8.5-15.9 0-5.2-4.3-9.4-9.6-9.4m-1.6 9.6a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0m5.6 0a4 4 0 1 0-8 0 4 4 0 0 0 8 0" })
});
export default SvgLocationPinRegularIcon;
